module.exports = __webpack_public_path__ + "static/media/icon-printer.d59b159e.svg";